import {servicesFactory} from "../../../../services/serviceFactory.js";
import { ProgramBoardModel } from '../../../../models/app/programBoardModel';

const getDefaultBoards = () => {
    return {
        // boards: [],
        programBoards: []
    }
};

export default {
    namespaced: true,
    state: getDefaultBoards(),
    getters: {
        boards: (state) => (programId) => {
            var filteredBoards = state.programBoards.filter(function (obj) {
                return obj.ProgramId == programId;
            });
            return filteredBoards[0] ? filteredBoards[0].Boards : [];
        },
        isBoardExist(state) {
            return (programId, subscriptionType) => state.programBoards.some(function (obj) {
                return obj.ProgramId == programId && obj.SubscriptionType === subscriptionType
            });
        }
    },
    mutations: {
        setBoards(state, model) {
            // state.boards = model.Boards;
            state.programBoards.push(model);
        },
        resetState(state, payload) {
            Object.assign(state, getDefaultBoards());
        }
    },
    actions: {
        getClassBoards({ commit, dispatch, rootState, getters }, param) {
            if (!getters.isBoardExist(param.data.AcademicProgramId, param.data.SubscriptionType)) {
                return servicesFactory.createService(servicesFactory.serviceType.enums.services.lmsService).courseService.getClassBoards(param).then(response => {
                    let programBoardModel = new ProgramBoardModel();
                    programBoardModel.ProgramId = param.data.AcademicProgramId;
                    programBoardModel.Boards = response.data.Boards;
                    programBoardModel.SubscriptionType = param.data.SubscriptionType
                    commit("setBoards", programBoardModel);

                    return Promise.resolve({ Boards: getters.boards(param.data.AcademicProgramId) });
                }).catch((ex) => {
                    if (process.env.VUE_ENV === 'client') {
                        throw new Error('Server Error');
                    }
                    console.log(ex.message);
                });
            } else {
                return Promise.resolve({ Boards: getters.boards(param.data.AcademicProgramId) });
            }
        },
        resetBoards({ state, commit }) {
            return commit("resetState");
        }
    }
};